import request from '@/utils/request'

export function phGetIotHealthDataTotal(phone) {
    return request({
        url: '/iotHealthData/total?phone=' + phone + '&queryNum=10',
        method: 'get',
    })
}
export function showCustomerAppointments(customerId, page, pageSize) {
    return request({
        url:
            '/phCrmActivity/showCustomerAppointments?customerId=' +
            customerId +
            '&page=' +
            page +
            '&pageSize=' +
            pageSize,
        method: 'get',
        data: {},
    })
}

export function getAlarmData() {
    return request({
        url: '/alertEvent/todayEvents',
        method: 'get',
        data: {},
    })
}


export function updateEventStatus(eventId, status) {
    return request({
        url: '/alertEvent/updateEventStatus',
        method: 'post',
        data: { 'id': eventId, 'status': status },
    })
}

export function getIncrementEvents() {
    return request({
        url: '/alertEvent/getIncrementEvents',
        method: 'get',
        data: {},
    })
}
export function getToken(uploadInfo) {
    return request({
        url: 'upload/token',
        method: 'post',
        data: uploadInfo,
    })
}
export function uploadPlatformUserImage(data) {
    return request({
        url: '/platformUser/image',
        method: 'post',
        data: data,
    })
}
//门店详情
export function getStoreDetail(storeId) {
    return request({
        url: '/store/detail/' + storeId,
        method: 'get'
    });
}
export function getDayDishes(data) {
    return request({
        url: '/dailyDishes/getDayDishes',
        method: 'post',
        data: data,
    })
}
export function getStoreCategoryMedias(storeId, code) {
    return request({
        url: `category/findStoreCategoryMedias?storeId=${storeId}&code=${code}`,
        method: 'get',
        showLoading: false
    });
}
// 门店列表
export function getUserStoresWithTenantId(tenantId) {
    return request({
        url: 'store/findStoreByTenantId?tenantId=' + tenantId,
        method: 'get',
        data: null,
    })
}